import React from "react";
import SvgIcon from "@material-ui/core/SvgIcon";
import MoreIcon from "@material-ui/icons/MoreVert";
import AddIcon from "@material-ui/icons/Add";
import AddCircleIcon from "@material-ui/icons/AddCircleOutline";
import CheckIcon from "@material-ui/icons/Check";
import ArrowRightIcon from "@material-ui/icons/ArrowForward";
import ArrowLeftIcon from "@material-ui/icons/ArrowBack";
import ArrowDownIcon from "@material-ui/icons/ArrowDownward";
import BookmarkedIcon from "@material-ui/icons/Bookmark";
import UnbookmarkedIcon from "@material-ui/icons/BookmarkBorder";
import PickedIcon from "@material-ui/icons/Star";
import UnpickedIcon from "@material-ui/icons/StarBorder";
import CrossIcon from "@material-ui/icons/Close";
import CloudUploadIcon from "@material-ui/icons/CloudUpload";
import FaceIcon from "@material-ui/icons/Mood";
import LockIcon from "@material-ui/icons/LockOpen";
import BreadcrumbsIcon from "@material-ui/icons/NavigateNext";
import ViewModuleIcon from "@material-ui/icons/ViewModule";
// import InfoIcon from "@material-ui/icons/Info";
import MenuBookIcon from "@material-ui/icons/MenuBook";
import ExploreIcon from "@material-ui/icons/Explore";
import AccountCircleIcon from "@material-ui/icons/AccountCircle";
import SearchIcon from "@material-ui/icons/Search";
import PortfolioIcon from "@material-ui/icons/RecentActors";
import RefreshIcon from "@material-ui/icons/Refresh";
import ExpandLessIcon from "@material-ui/icons/ExpandLess";
import ExpandMoreIcon from "@material-ui/icons/ExpandMore";
import AddNoteIcon from "@material-ui/icons/PlaylistAdd";
import PersonIcon from "@material-ui/icons/PersonOutline";
import PublicIcon from "@material-ui/icons/Public";
import PrivateIcon from "@material-ui/icons/Lock";
import PropTypes from "prop-types";

CommonIconView.propTypes = {
  type: PropTypes.oneOf([
    "more",
    "add",
    "addCircle",
    "check",
    "next",
    "back",
    "moreRequest",
    "bookmarked",
    "unbookmarked",
    "picked",
    "unpicked",
    "close",
    "submit",
    "addSticker",
    "lockOpen",
    "breadcrumb",
    "vote",
    "lookbook",
    "search",
    "portfolio",
    "refresh",
    "expandMore",
    "expandLess",
    "addNote",
    "person",
    "info",
    "travel",
    "public",
    "private",
    "login"
  ]).isRequired,

  fontSize: PropTypes.oneOf(["inherit", "medium", "small", "large"]),
  style: PropTypes.object
};

CommonIconView.defaultProps = {
  fontSize: "medium",
  style: undefined
};

function CommonIconView(props) {
  const { type, fontSize, style } = props;

  const getHeartSvg = () => (
    <path
      d="M 12 4.923
    C 18.981 .95 25.104 9.476 20.272 14.594
    C 19.188 15.743 16.973 17.495 16.256 17.945
    C 12.5 20.929 11.5 20.929 7.744 17.945
    C 7.027 17.495 4.812 15.743 3.727 14.594
    C -1.104 9.477 5.019 .95 12 4.923
    Z"
    />
  );

  const getIcon = () => {
    if (type === "more") {
      return <MoreIcon fontSize={fontSize} style={style} />;
    } else if (type === "add") {
      return <AddIcon fontSize={fontSize} style={style} />;
    } else if (type === "addCircle") {
      return <AddCircleIcon fontSize={fontSize} style={style} />;
    } else if (type === "check") {
      return <CheckIcon fontSize={fontSize} style={style} />;
    } else if (type === "next") {
      return <ArrowRightIcon fontSize={fontSize} style={style} />;
    } else if (type === "back") {
      return <ArrowLeftIcon fontSize={fontSize} style={style} />;
    } else if (type === "moreRequest") {
      return <ArrowDownIcon fontSize={fontSize} style={style} />;
    } else if (type === "bookmarked") {
      return <BookmarkedIcon fontSize={fontSize} style={style} />;
    } else if (type === "unbookmarked") {
      return <UnbookmarkedIcon fontSize={fontSize} style={style} />;
    } else if (type === "picked") {
      return <PickedIcon fontSize={fontSize} style={style} />;
    } else if (type === "unpicked") {
      return <UnpickedIcon fontSize={fontSize} style={style} />;
    } else if (type === "close") {
      return <CrossIcon fontSize={fontSize} style={style} />;
    } else if (type === "submit") {
      return <CloudUploadIcon fontSize={fontSize} style={style} />;
    } else if (type === "addSticker") {
      return <FaceIcon fontSize={fontSize} style={style} />;
    } else if (type === "lockOpen") {
      return <LockIcon fontSize={fontSize} style={style} />;
    } else if (type === "breadcrumb") {
      return <BreadcrumbsIcon fontSize={fontSize} style={style} />;
    } else if (type === "vote") {
      return (
        <SvgIcon fontSize={fontSize} style={style}>
          {getHeartSvg()}
        </SvgIcon>
      );
    } else if (type === "lookbook") {
      return <ViewModuleIcon fontSize={fontSize} style={style} />;
    } else if (type === "search") {
      return <SearchIcon fontSize={fontSize} style={style} />;
    } else if (type === "portfolio") {
      return <PortfolioIcon fontSize={fontSize} style={style} />;
    } else if (type === "refresh") {
      return <RefreshIcon fontSize={fontSize} style={style} />;
    } else if (type === "expandMore") {
      return <ExpandMoreIcon fontSize={fontSize} style={style} />;
    } else if (type === "expandLess") {
      return <ExpandLessIcon fontSize={fontSize} style={style} />;
    } else if (type === "addNote") {
      return <AddNoteIcon fontSize={fontSize} style={style} />;
    } else if (type === "person") {
      return <PersonIcon fontSize={fontSize} style={style} />;
    } else if (type === "info") {
      return <MenuBookIcon fontSize={fontSize} style={style} />;
      // return <InfoIcon fontSize={fontSize} style={style} />;
    } else if (type === "travel") {
      return <ExploreIcon fontSize={fontSize} style={style} />;
    } else if (type === "public") {
      return <PublicIcon fontSize={fontSize} style={style} />;
    } else if (type === "private") {
      return <PrivateIcon fontSize={fontSize} style={style} />;
    } else if (type === "login") {
      return <AccountCircleIcon fontSize={fontSize} style={style} />;
    }
  };

  return getIcon();
}

export default CommonIconView;
